import { loadJQuery } from '../async/loadJQuery.js';
import { logError } from '../utils/logError';

export const initGiftsSpecificButtons = function() {
    $('.gSex a').on('click', async function(e){
        try {
            await loadJQuery();
            // e.preventDefault();
            var p = $(this).parent();
            $('.gSex').removeClass('sel');
            p.addClass('sel');
            jQuery('.hiddenGiftBlock').slideDown(300);
            $('.gOpen').addClass('gOpenTall');
            $('.g-person-type').removeClass('sel');
            if (p.hasClass('gMbox')) {
                $('.gptM').addClass('sel');
            } else {
                $('.gptF').addClass('sel');
            }
        } catch (error) {
            logError(error);
        }
    });

    $('html').on('click', '.js-gifts-products-load', function(e) {
        let el = $(this);

        // Show hidden products block
        let hiddenBlock = el.closest('.js-gifts-section').find('.js-extra-gift-products');
        hiddenBlock.show();
        el.hide('fade');
    });

    //LINKS TO SELECT EXECUTE
    $(document).on('click', '.gifts .selectbox-title', function(){
        $('.gifts ul').toggle();
    });
}
